// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, type Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import {
	dialogWidth,
	dialogPageCentreWidth,
	dialogPageTakeoverWidth,
	enlargedInputFieldHeight,
	inputFieldHeight,
} from '../style-utils';
import { zIndex } from '../z-index';
import type { DetailedHTMLProps, HTMLAttributes, ClassAttributes } from 'react';

import { SearchAnchorWrapper } from './search-anchor-wrapper';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { AbsoluteContainer } from './absolute-container';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { SearchAnchorWrapper } from './search-anchor-wrapper';

interface IsExpandedProp {
	isExpanded: boolean;
	shouldFillContainer?: boolean;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SearchDialogAnchor: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	} & IsExpandedProp,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled('div')(
	{
		position: 'relative',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props: IsExpandedProp) => {
		if (props.isExpanded) {
			// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			return css`
				${
					/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''
				}

				@media screen and (max-width: ${dialogPageCentreWidth}) {
					${/* eslint-enable */ ''}
					position: ${props.shouldFillContainer ? 'static' : 'fixed'};
					${
						/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''
					}
					z-index: ${zIndex.searchDialog};
					left: calc((100% - ${dialogWidth}) / 2);
					${/* eslint-enable */ ''}
				}

				${
					/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''
				}
				@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
					${/* eslint-enable */ ''}

					${props.shouldFillContainer && 'position: fixed;'};
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					display: flex;
					flex-direction: column;
					overflow: auto;
				}
			`;
		}
		return {};
	},
);

// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedSearchAnchorWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & {
		shouldFillContainer?: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
		} & IsExpandedProp,
	{},
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(SearchAnchorWrapper)<IsExpandedProp>((props) => ({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	height: props.isExpanded ? enlargedInputFieldHeight.px : inputFieldHeight.px,
}));
